<template>
  <div data-grm-comp="RoomCBTLogUserList">
    <table>
      <colgroup>
        <col width="10%">
        <col width="3%">
        <col width="10%">
        <col width="3%">
      </colgroup>
      <thead>
      <tr>
        <th>이름</th>
        <th>점수</th>
        <th>참여 시간</th>
        <th>결과 보기</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(roomCbtUser) in cbtLog.roomCbtUserLogList" :key="roomCbtUser.userId">
        <td>{{ roomCbtUser.username }}</td>
        <td>{{ roomCbtUser.totalScore }}</td>
        <td>{{ dayjs(roomCbtUser.beginDate).format('YYYY-MM-DD HH:mm:ss') }} ~ {{ dayjs(roomCbtUser.endDate).format('YYYY-MM-DD HH:mm:ss') }}</td>
        <td>
          <div class="flex justify-center items-center gap-1">
            <GrmBtn size="xs" @click="onSelectCBT(roomCbtUser)">보기</GrmBtn>
          </div>
        </td>
      </tr>
      <tr v-if="cbtLog.roomCbtUserLogList.length === 0">
        <td colspan="4">출제한 사용자가 없습니다.</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import dayjs from "dayjs";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import RoomCBTLogUser from "@/components/Room/CBT/RoomCBTLogUser.vue";

export default {
  name: 'RoomCBTLogUserList',
  components: {
    GrmBtn
  },
  computed: {
    ...mapState('cbt', [
      'cbtLog',
      'cbtLogList',
    ]),

    duration() {
      return duration => {
        const hour = Math.floor(duration / 3600);
        const minute = Math.floor((duration % 3600) / 60);
        const second = duration % 60;
        return `${hour ? hour + this.$t('common.hour') + ' ' : ''}${minute ? minute + this.$t('common.minute') + ' ' : ''}${second ? second + this.$t('common.second') : ''}`;
      }
    }
  },
  methods: {
    ...mapMutations('cbt', [
      'SET_CBT_LOG_USER'
    ]),

    dayjs,
    onSelectCBT(roomCbtUser) {
      this.SET_CBT_LOG_USER(roomCbtUser);
      this.$modal(RoomCBTLogUser, {
        data: {
          roomCbtUser
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
  border: 1px solid #ccc;
}
thead {
  tr {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
tbody {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  &:first-child {
    border-top: none;
  }
}
tr {
  height: 40px;
  white-space: nowrap;
}
th {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
td {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
</style>